@if (!isDestroyed) {
    <af-full-table
        class="w-100 h-100"
        [filterFields]="filterFields"
        [filterEvent]="tableEvent.filter"
        [pageEvent]="tableEvent.page"
        (tableUpdateListener)="loadUsers($event)"
        [dataSource]="dataSource"
        [totalElements]="totalElements"
        (emptyStateClickListener)="buttonClickStream.next('tabUsers')"
        [showImport]="false"
        [showExport]="false"
        emptyStateIconName="ic_empty_state_data_no_created"
        emptyStateTitleTranslationKey="i18n_af_emptyStateTitleDataNotCreatedUsers"
        emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleDataNotCreatedUsers"
        emptyStateButtonLabel="i18n_af_buttonCreateUser"
        totalElementsTranslationKey="i18n_af_labelTotalElementsUsers"
        placeholderContext="users"/>
}
